export enum TabKey {
  Product,
  Evaluate,
  Description,
  Recommend,
}

export const domYState: Record<string, HTMLDivElement | null> = {
  [TabKey.Product]: null,
  [TabKey.Evaluate]: null,
  [TabKey.Description]: null,
  [TabKey.Recommend]: null,
};

/**
 * 更新 节点的 y 位置.
 * @param param0
 * @returns void
 */
export function updateState({ name, el }: { name: TabKey; el: HTMLDivElement | null }): void {
  if (typeof domYState[name] === "undefined") return;
  domYState[name] = el;
}
